import React from "react";
import { Helmet } from "react-helmet-async";
import { useI18n } from "../i18n/I18nContext";
import { ContactInfo } from "../Utils/Data";

export const SITE_URL = (process.env.REACT_APP_SITE_URL || "https://q-techksa.com").replace(/\/+$/, "");
export const DEFAULT_SEO_IMAGE = "/img/logo-black.png";

export const ARABIC_SEO_KEYWORDS = {
  home:
    "شركة تقنيات الجودة، شركة عقارية، خدمات عقارية، خدمات عقارية في الخبر، شركة عقارية في الخبر، وسيط عقاري، صيانة مباني، شركات صيانة، إدارة أملاك، ادارة املاك، تسويق عقاري، تسويق عقاري في المنطقة الشرقية، تسويق عقاري في الخبر، تسويق عقاري في الدمام، عقود عقارية",
  services:
    "خدمات عقارية، خدمات عقارية في السعودية، خدمات عقارية في الخبر، شركة عقارية، شركة عقارية في الخبر، إدارة أملاك، وساطة عقارية، تسويق عقاري، صيانة مباني، تطوير عقاري",
  propertyManagement:
    "إدارة أملاك، ادارة املاك، إدارة الأملاك، إدارة عقارات، شركة إدارة أملاك، شركة إدارة عقارات، إدارة أملاك في الخبر، إدارة العقارات السكنية، إدارة العقارات التجارية، تحصيل الإيجارات، متابعة المستأجرين، صيانة العقارات",
  brokerage:
    "وساطة عقارية، وسيط عقاري، وسيط عقاري في الخبر، وسيط عقاري في الدمام، عقود عقارات، عقود عقارات في الخبر، وسيط بين المالك والمشتري، وسيط بين المالك والمستأجر، بيع عقارات في الخبر، تأجير عقارات في الخبر",
  marketing:
    "تسويق عقاري، تسويق عقارات، تسويق عقاري في الخبر، تسويق عقاري في الدمام، تسويق عقاري في المنطقة الشرقية، شقق للبيع، شقق للإيجار، شقق للبيع في الخبر، عقارات للبيع في الخبر، عقارات الشرقية، شقق في حي الحمراء، شقق للإيجار في الحمراء، شقق للبيع في الحمراء، شقق للبيع في العزيزية، شقق للبيع في البحيرة، عقارات حي البحيرة، عقارات بالقرب من جسر البحرين، فلل للبيع، فلل للبيع في الخبر، تأجير شقق في الخبر، شقق في كومباوند، شقة مفروشة للإيجار، وحدات للبيع في الخبر، وحدات للإيجار، شقق للاستثمار، استثمار عقاري",
  development:
    "تطوير عقاري، التطوير العقاري، عقارات في الخبر، مطور عقاري، مطور عقاري في الخبر، مقاول، مقاولات في الخبر، شركات مقاولات، شركات مقاولات في الخبر، تطوير مشاريع عقارية، إدارة مشاريع عقارية",
  maintenance:
    "صيانة مباني، صيانة عقارات، شركات صيانة، شركات صيانة في الخبر، شركات صيانة في الدمام، صيانة مصاعد في الخبر، صيانة مصاعد في الدمام، سباكة مباني، أعمال كهرباء، تصليح مياه، صيانة شاملة في الخبر، صيانة شاملة في الدمام، توفير فنيين، أنظمة أمن، مراقبة، كاميرات، تركيب كاميرات في الخبر، تركيب كاميرات في الدمام، صيانة وتشغيل العقارات، إدارة المرافق",
  property:
    "عقارات للبيع في الخبر، عقارات للإيجار في الخبر، عقارات في الخبر، عقارات الشرقية، شقق للبيع، شقق للإيجار، شقق للبيع في الخبر، شقق للإيجار في الخبر، فلل للبيع، فلل للبيع في الخبر، وحدات للبيع في الخبر، وحدات للإيجار، شقق للاستثمار، استثمار عقاري",
};

export const ENGLISH_SEO_KEYWORDS = {
  services:
    "real estate services Saudi Arabia, real estate company Al Khobar, property management Saudi Arabia, real estate brokerage Saudi Arabia, real estate marketing Saudi Arabia, property maintenance Saudi Arabia, property development Saudi Arabia, real estate services Eastern Province",
  propertyManagement:
    "property management Saudi Arabia, property management company Al Khobar, property management services Saudi Arabia, residential property management Saudi Arabia, commercial property management Saudi Arabia, rent collection services, tenant coordination, lease administration",
  brokerage:
    "real estate brokerage Saudi Arabia, real estate broker Al Khobar, property brokerage Saudi Arabia, buy property Saudi Arabia, sell property Saudi Arabia, lease property Saudi Arabia, real estate negotiation services, property transaction support",
  marketing:
    "real estate marketing Saudi Arabia, property marketing Al Khobar, real estate advertising Saudi Arabia, digital marketing for properties, property campaign management, real estate lead generation, property listing marketing, real estate promotion Eastern Province",
  maintenance:
    "property maintenance Saudi Arabia, building maintenance Al Khobar, facility operations Saudi Arabia, preventive maintenance services, real estate maintenance company, technical property support, building operations Eastern Province, maintenance and operations services",
  development:
    "property development Saudi Arabia, real estate development Al Khobar, development management Saudi Arabia, real estate project development, feasibility review Saudi Arabia, project supervision real estate, consultant coordination, property development services",
};

const absoluteUrl = (path = "/") => {
  if (/^https?:\/\//i.test(path)) return path;
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
};

export const organizationStructuredData = {
  "@context": "https://schema.org",
  "@type": ["Organization", "RealEstateAgent", "LocalBusiness"],
  name: "QTECH",
  url: SITE_URL,
  logo: absoluteUrl(DEFAULT_SEO_IMAGE),
  image: absoluteUrl(DEFAULT_SEO_IMAGE),
  email: ContactInfo.contact_email,
  telephone: ContactInfo.contact_phone,
  address: {
    "@type": "PostalAddress",
    streetAddress: ContactInfo.office_address_line1,
    addressLocality: "Al Khobar",
    addressRegion: "Eastern Province",
    postalCode: "34722",
    addressCountry: "SA",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: ContactInfo.office_map_lat,
    longitude: ContactInfo.office_map_lng,
  },
  areaServed: {
    "@type": "Country",
    name: "Saudi Arabia",
  },
  sameAs: [
    ContactInfo.facebook,
    ContactInfo.X,
    ContactInfo.instagram,
    ContactInfo.tiktok,
    ContactInfo.snapchat,
  ].filter(Boolean),
};

export const websiteStructuredData = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "QTECH",
  url: SITE_URL,
  potentialAction: {
    "@type": "SearchAction",
    target: `${SITE_URL}/property?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

export const buildServiceStructuredData = ({
  name,
  nameAr,
  description,
  descriptionAr,
  path,
  image = DEFAULT_SEO_IMAGE,
  serviceType,
}) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name,
  alternateName: nameAr,
  description,
  additionalProperty: [
    nameAr
      ? { "@type": "PropertyValue", name: "Arabic Name", value: nameAr }
      : null,
    descriptionAr
      ? { "@type": "PropertyValue", name: "Arabic Description", value: descriptionAr }
      : null,
  ].filter(Boolean),
  serviceType,
  provider: {
    "@type": "RealEstateAgent",
    name: "QTECH",
    url: SITE_URL,
  },
  areaServed: {
    "@type": "Country",
    name: "Saudi Arabia",
  },
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name,
    itemListElement: [
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name,
          description,
        },
      },
    ],
  },
  url: absoluteUrl(path),
  image: absoluteUrl(image),
});

export const buildServicesHubStructuredData = (services) => ({
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "QTECH Real Estate Services",
  itemListOrder: "https://schema.org/ItemListOrderAscending",
  numberOfItems: services.length,
  itemListElement: services.map((service, index) => ({
    "@type": "ListItem",
    position: index + 1,
    url: absoluteUrl(service.path),
    name: service.name,
  })),
});

export const mergeSeoKeywords = (...groups) => {
  const seen = new Set();
  const merged = [];

  groups
    .flat()
    .filter(Boolean)
    .forEach((group) => {
      String(group)
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean)
        .forEach((item) => {
          const key = item.toLowerCase();
          if (seen.has(key)) return;
          seen.add(key);
          merged.push(item);
        });
    });

  return merged.join(", ");
};

const Seo = ({
  title,
  titleAr,
  description,
  descriptionAr,
  keywords,
  keywordsAr,
  path = "/",
  image = DEFAULT_SEO_IMAGE,
  type = "website",
  noindex = false,
  structuredData,
}) => {
  const { locale } = useI18n();
  const isArabic = locale === "ar";
  const localizedTitle = isArabic && titleAr ? titleAr : title;
  const localizedDescription = isArabic && descriptionAr ? descriptionAr : description;
  const localizedKeywords = isArabic && keywordsAr ? keywordsAr : keywords;
  const canonicalUrl = absoluteUrl(path);
  const imageUrl = absoluteUrl(image);
  const schemaItems = [
    organizationStructuredData,
    websiteStructuredData,
    ...(Array.isArray(structuredData) ? structuredData : structuredData ? [structuredData] : []),
  ];

  return (
    <Helmet htmlAttributes={{ lang: isArabic ? "ar" : "en", dir: isArabic ? "rtl" : "ltr" }}>
      <title>{localizedTitle}</title>
      {localizedDescription ? <meta name="description" content={localizedDescription} /> : null}
      {localizedKeywords ? <meta name="keywords" content={localizedKeywords} /> : null}
      <link rel="canonical" href={canonicalUrl} />
      <link rel="alternate" hrefLang="en" href={canonicalUrl} />
      <link rel="alternate" hrefLang="ar" href={canonicalUrl} />
      <link rel="alternate" hrefLang="ar-SA" href={canonicalUrl} />
      <link rel="alternate" hrefLang="x-default" href={canonicalUrl} />
      {noindex ? <meta name="robots" content="noindex,follow" /> : <meta name="robots" content="index,follow" />}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="QTECH" />
      <meta property="og:title" content={localizedTitle} />
      {localizedDescription ? <meta property="og:description" content={localizedDescription} /> : null}
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:locale" content={isArabic ? "ar_SA" : "en_US"} />
      <meta property="og:locale:alternate" content={isArabic ? "en_US" : "ar_SA"} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={localizedTitle} />
      {localizedDescription ? <meta name="twitter:description" content={localizedDescription} /> : null}
      <meta name="twitter:image" content={imageUrl} />
      <script type="application/ld+json">{JSON.stringify(schemaItems)}</script>
    </Helmet>
  );
};

export default Seo;
